import { type MiniProfile } from "./types";

export const TEXT_FIELD_ID = "41CF0166-76A6-4165-9ACF-37B918235FD1";
export const NAME_FIELD_ID = "B599E333-FFCF-4F20-8434-51F883DE08EA";
export const EMAIL_FIELD_ID = "C667ED4C-DDC8-4461-9D77-335A27D08432";
export const PHONE_FIELD_ID = "EBCB47B0-19B3-47F2-B1D1-B19BADE3E987";

export const DUMMY_PROFILE: MiniProfile.Api.InitResponse = {
  profilePictureMediaSourceId: null,
  profilePictureMediaSourceKey: null,
  items: [
    {
      fieldId: EMAIL_FIELD_ID,
      value: "Email",
      formControlKey: "text"
    },
    {
      fieldId: NAME_FIELD_ID,
      value: "Name",
      formControlKey: "text"
    },
    {
      fieldId: PHONE_FIELD_ID,
      value: "Phone",
      formControlKey: "text"
    }
  ]
};
